// Top-level frame node = "Section". Serif `§N · Label` header + italic gray
// subtitle, mirroring the prototype-cases rhythm. Borrows the warm-paper
// design tokens (Fraunces, JetBrains Mono).

export interface SectionProps {
  index: number;
  label: string;
  subtitle?: string;
  totalCards: number;
  isGap: boolean;
  onGapClick?: () => void;
  children?: React.ReactNode;
}

export function Section({
  index, label, subtitle, totalCards, isGap, onGapClick, children,
}: SectionProps) {
  return (
    <section style={{ marginTop: 22 }}>
      <header
        style={{
          padding: '0 18px 6px',
          borderBottom: '1px solid var(--rule)',
          marginBottom: 10,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' }}>
          <h2
            className="serif"
            style={{
              fontSize: 21,
              fontWeight: 500,
              letterSpacing: '-0.005em',
              color: 'var(--ink-0)',
              margin: 0,
            }}
          >
            <span style={{ color: 'var(--ink-3)', fontWeight: 400, marginRight: 6 }}>
              §{index}
            </span>
            <span style={{ color: 'var(--ink-3)', fontWeight: 400, marginRight: 6 }}>·</span>
            {label}
          </h2>
          {subtitle && (
            <span
              style={{
                fontSize: 12.5,
                color: 'var(--ink-3)',
                fontStyle: 'italic',
                fontWeight: 400,
              }}
            >
              {subtitle}
            </span>
          )}
          <span style={{ flex: 1 }} />
          <span
            className="mono"
            style={{
              fontSize: 10,
              color: 'var(--ink-3)',
              letterSpacing: '.05em',
            }}
          >
            {totalCards} card{totalCards === 1 ? '' : 's'}
          </span>
          {isGap && (
            <button
              onClick={onGapClick}
              className="mono"
              style={{
                fontSize: 9.5,
                letterSpacing: '.08em',
                fontWeight: 700,
                color: 'var(--amber)',
                padding: '2px 7px',
                border: '1px solid var(--amber)',
                borderRadius: 3,
                background: 'var(--amber-soft)',
                cursor: 'pointer',
              }}
              title="this MECE node is empty — open probe questions"
            >
              GAP →
            </button>
          )}
        </div>
      </header>
      <div style={{ padding: '0 18px' }}>{children}</div>
    </section>
  );
}
